var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.countryCode)?_c('v-avatar',{style:(_vm.borderStyle),attrs:{"rounded":_vm.avatar ? false : true,"size":_vm.size ? _vm.size : _vm.defaultSize}},[_c('v-img',{attrs:{"src":_vm.imagePath},on:{"error":function($event){return _vm.imageError()}}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }